import React from 'react';
import Home from '../component/home';
import Services from '../component/services';
import Counter from '../component/counter';
import WorkProcess from '../component/workProcess';
import Contact from '../component/contact';
import Footer from '../component/footer';
import Navbar from '../component/navbar';



const LandingPage = () => {
document.title =" Landing | Ordering Management System";

window.onscroll = function () {
    scrollFunction();
};

const scrollFunction = () => {
    const element = document.getElementById("back-to-top");
    if (element) {
        if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
            element.style.display = "block";
        } else {
            element.style.display = "none";
        }
    }
};

const toTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
};

    return (
        <React.Fragment>            
            <div className="layout-wrapper landing">
                <Navbar />
                <Home />
                <Services />
                <Counter />
                <WorkProcess />
                <Contact />
                <Footer />
                <button onClick={() => toTop()} className="btn btn-danger btn-icon landing-back-top" id="back-to-top">
                    <i className="ri-arrow-up-line"></i>
                </button>
            </div>
        </React.Fragment>
    );
};

export default LandingPage;